// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3HdEx","type":"styles_type__Ql2W8","choices":"styles_choices__slS-N"};